(function () {
	const SELECTOR = '[data-eyesnug-menu-item]';

	const initVisualNavigation = (root = document) => {
		const menuItems = root.querySelectorAll(`${SELECTOR}:not([data-eyesnug-menu-ready])`);
		if (!menuItems.length) return;

		const closeMenu = (item, { returnFocus = false } = {}) => {
			const trigger = item.querySelector('.eyesnug-menu-trigger');
			if (!trigger) return;
			item.classList.remove('is-open');
			trigger.setAttribute('aria-expanded', 'false');
			if (returnFocus) trigger.focus();
		};

		const closeAll = (exceptItem) => {
			document.querySelectorAll(`${SELECTOR}.is-open`).forEach((item) => {
				if (item !== exceptItem) closeMenu(item);
			});
		};

		const openMenu = (item) => {
			const trigger = item.querySelector('.eyesnug-menu-trigger');
			if (!trigger) return;
			closeAll(item);
			item.classList.add('is-open');
			trigger.setAttribute('aria-expanded', 'true');
		};

		menuItems.forEach((item) => {
			item.dataset.eyesnugMenuReady = 'true';
			const trigger = item.querySelector('.eyesnug-menu-trigger');
			if (!trigger) return;

			trigger.addEventListener('click', (event) => {
				event.preventDefault();
				if (item.classList.contains('is-open')) {
					closeMenu(item);
				} else {
					openMenu(item);
				}
			});

			item.addEventListener('mouseenter', () => openMenu(item));
			item.addEventListener('mouseleave', () => closeMenu(item));
			item.addEventListener('focusin', () => openMenu(item));
			item.addEventListener('focusout', (event) => {
				if (!item.contains(event.relatedTarget)) closeMenu(item);
			});

			item.addEventListener('keydown', (event) => {
				if (event.key !== 'Escape') return;
				event.preventDefault();
				closeMenu(item, { returnFocus: true });
			});
		});

		if (!document.documentElement.dataset.eyesnugNavigationGlobalReady) {
			document.documentElement.dataset.eyesnugNavigationGlobalReady = 'true';

			document.addEventListener('click', (event) => {
				if (!event.target.closest(SELECTOR)) closeAll();
			});

			window.addEventListener('resize', () => {
				if (window.innerWidth < 1100) closeAll();
			});
		}
	};

	document.addEventListener('shopify:section:load', (event) => initVisualNavigation(event.target));
	document.addEventListener('DOMContentLoaded', () => initVisualNavigation());

	if (document.readyState !== 'loading') initVisualNavigation();
})();
